var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isImpersonating)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.onReturnYourself}},[_c('b-badge',{staticClass:"badge-impersonate",attrs:{"pill":""}},[_vm._v("\n    Back to yourself\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }